import React, { Component } from 'react';

export default class extends Component {
  render () {
    return <div className='col col-12 col-lg-9'>
      <h1>Hey!</h1>
      <p>Please, use navigation bar</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/admins/UserWelcome.js